import constants from '../constants'

/* Default Config:  Only set config if you want to change these default values for a market
    hideShippingInstructions: false,
    hideEmailField: false,
    hideDefaultCheckbox: false,
    hideSaveCheckbox: false,
    requireEmail: false,
    requireShippingInstructions: false,
    requireShippingPhone: false,
    requireShippingMobilePhone: false,
    showMobilePhoneField: false
 */

export const SHIPPING_ADDRESS_CONFIG = {
    "AR": {
        "requireEmail": true,
        "requireShippingPhone": true
    },
    "AT": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "AU": {
        "requireShippingInstructions": true,
        "requireShippingPhone": true
    },
    "BE": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "BN": {
        "hideShippingInstructions": true,
        "hideEmailField": true,
        "requireShippingPhone": true
    },
    "BR": {
        "hideShippingInstructions": true,
        "hideEmailField": true,
        "requireShippingPhone": true
    },
    "CA": {
        "requireShippingPhone": true
    },
    "CH": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "CL": {
        "requireShippingPhone": true
    },
    "CO": {
        "hideEmailField": true,
        "requireShippingPhone": true
    },
    "CR": {
        "hideShippingInstructions": true,
        "hideEmailField": true,
        "requireShippingPhone": true
    },
    "CZ": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "DE": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "DK": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "ES": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "FI": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "FR": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "GB": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "GT": {
        "hideShippingInstructions": true,
        "hideEmailField": true,
        "requireShippingPhone": true
    },
    "HK": {
        "hideShippingInstructions": true,
        "hideEmailField": true,
        "requireShippingPhone": true
    },
    "HN": {
        "hideShippingInstructions": true,
        "hideEmailField": true,
        "requireShippingPhone": true
    },
    "HU": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "ID": {
        "hideShippingInstructions": true,
        "hideEmailField": true,
        "requireShippingPhone": true
    },
    "IE": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingPhone": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "IL": {
        "requireShippingPhone": true
    },
    "IS": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "IT": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "JP": {
        "hideShippingInstructions": true,
        "hideEmailField": true,
        "recipientFieldEditableOnlyByBrandAffiliates": true,
        "requireShippingPhone": true,
        "shippingAddressNameRegex": constants.JP.regex.allowedCharacters
    },
    "LU": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "MX": {
        "requireShippingPhone": true
    },
    "MY": {
        "hideShippingInstructions": true,
        "hideEmailField": true,
        "requireShippingPhone": true
    },
    "NC": {
        "requireShippingPhone": true
    },
    "NL": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true,
        "countryList": [
            {"value": "NL", "label": "Netherlands"},
            {"value": "AT", "label": "Austria"},
            {"value": "BE", "label": "Belgium"},
            {"value": "CZ", "label": "Czech Republic"},
            {"value": "DK", "label": "Denmark"},
            {"value": "FI", "label": "Finland"},
            {"value": "FR", "label": "France"},
            {"value": "DE", "label": "Germany"},
            {"value": "HU", "label": "Hungary"},
            {"value": "IS", "label": "Iceland"},
            {"value": "IE", "label": "Ireland"},
            {"value": "IT", "label": "Italy"},
            {"value": "LU", "label": "Luxembourg"},
            {"value": "NO", "label": "Norway"},
            {"value": "PL", "label": "Poland"},
            {"value": "PT", "label": "Portugal"},
            {"value": "RO", "label": "Romania"},
            {"value": "ES", "label": "Spain"},
            {"value": "SK", "label": "Slovakia"},
            {"value": "SE", "label": "Sweden"},
            {"value": "CH", "label": "Switzerland"},
            {"value": "GB", "label": "United Kingdom"}
        ]
    },
    "NO": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "NZ": {
        "requireShippingPhone": true
    },
    "PE": {
        "requireEmail": true
    },
    "PF": {
        "requireShippingPhone": true
    },
    "PH": {
        "hideShippingInstructions": true,
        "hideEmailField": true
    },
    "PL": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "PT": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "RO": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "RU": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingPhone": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "SE": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "SG": {
        "hideShippingInstructions": true,
        "hideEmailField": true,
        "requireShippingPhone": true
    },
    "SK": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "SV": {
        "hideShippingInstructions": true,
        "requireShippingPhone": true
    },
    "TH": {
        "hideEmailField": true,
        "requireShippingPhone": true
    },
    "TR": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "UA": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingMobilePhone": true,
        "showMobilePhoneField": true
    },
    "US": {
        "requireShippingPhone": true
    },
    "VE": {
        "hideEmailField": true,
        "requireShippingPhone": true
    },
    "VN": {
        "hideEmailField": true,
        "requireShippingPhone": true
    },
    "ZA": {
        "hideShippingInstructions": true,
        "requireEmail": true,
        "requireShippingPhone": true,
        "showMobilePhoneField": false
    }
};
